const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M9.01 5.393A7.3 7.3 0 0 1 12 4.75c1.78 0 3.41.641 4.671 1.705a7.3 7.3 0 0 1 1.921 2.523A7.3 7.3 0 0 1 19.25 12a7.25 7.25 0 1 1-14.5 0 .75.75 0 0 0-1.5 0 8.75 8.75 0 1 0 2.5-6.125V3.75a.75.75 0 0 0-1.5 0V8c0 .414.336.75.75.75h4.25a.75.75 0 0 0 0-1.5H6.523A7.3 7.3 0 0 1 9.01 5.393"/></svg>';
export {
  a as w
};
